import {
    Component,
    EventEmitter,
    Input,
    OnInit
} from '@angular/core';
import {
    ClrDatagridFilterInterface
} from '@clr/angular';
import {
    LabelType
} from "@angular-slider/ngx-slider";
import {NetscopeUtils} from "@app/netscope/netscope-utils";
import {FlowsRepository} from "@app/netscope/model/flows-repository";


@Component({
    standalone: false,
    selector: 'column-range-filter',
    templateUrl: './range-filter.component.html',
    styleUrls: ['./range-filter.component.css']
})
export class RangeFilterComponent implements OnInit, ClrDatagridFilterInterface < any > {

    filterIsActive = false;

    @Input()
    fieldName;

    @Input()
    formatType: string = "default";

    @Input()
    items: any[];
    options = {
        floor: 0,
        ceil: 1,
        translate: (value: number, label: LabelType): string => {
            let formatFunction = (value) => value;

            if (this.formatType === "bytes") {
              formatFunction = this.formatBytes;
            }

            switch (label) {
                case LabelType.Low:
                    return `<b>Min:</b>${formatFunction(value)}`;
                case LabelType.High:
                    return `<b>Max:</b>${formatFunction(value)}`;
                default:
                    return `${formatFunction(value)}`;
            }
        },
        animate: false
    };

    @Input()
    flowsRepository: FlowsRepository

    @Input()
    tableUpdate: EventEmitter < any > ;

    minValue;
    maxValue;
    changes: any = new EventEmitter < any > (false);

    manualRefresh: EventEmitter < void > = new EventEmitter < void > ();

    ngOnInit() {
        this.initFilter();

        // If table config is not dynamic, there is no need to provide an event emitter
        if (this.tableUpdate != undefined) {
            this.tableUpdate.subscribe(items => {
                this.items = items;
                this.initFilter();
                this.manualRefresh.emit();
            });
        }
    }

    initFilter = () => {
        console.log(`call to initFilter(); with field ${this.fieldName}`);

        if (this.items == null) {
            this.items = [];
        }

        if (this.flowsRepository == undefined) {
          return;
        }

        // let boundaries = await this.flowsRepository.getRangeBoundaries(this.fieldName);

        let boundaries = this.flowsRepository.valuesForFilters[this.fieldName];

        this.minValue = boundaries.min;
        this.maxValue = boundaries.max;

        // Prevent a UI glitch that happens min and max have the same values
        if (this.minValue == this.maxValue) {
            this.maxValue += 1;
        }

        // NGX slider seems to truncate integer values. The following code adjusts minValue and maxValue
        // so that all values fit in the [minValue, maxValue] interval.
        this.minValue = Math.floor(this.minValue);
        this.maxValue = Math.ceil(this.maxValue);

        let formatFunction = (value) => value;

        if (this.formatType === "bytes") {
            formatFunction = this.formatBytes;
        }

        console.log(`updating options; with field ${this.fieldName}`);

        this.options = {
            floor: this.minValue,
            ceil: this.maxValue,
            translate: (value: number, label: LabelType): string => {
                switch (label) {
                    case LabelType.Low:
                        return `<b>Min:</b>${formatFunction(value)}`;
                    case LabelType.High:
                        return `<b>Max:</b>${formatFunction(value)}`;
                    default:
                        return `${formatFunction(value)}`;
                }
            },
            animate: false
        };
        console.log(`has updated options; with field ${this.fieldName}`);
        this.manualRefresh.emit();
    }

    formatBytes = (value, units = ["bytes", "KiB", "MiB", "GiB", "TiB"]) => {
        if (value < 1024 || units.length === 1) {
            // Check if the number has decimals (https://stackoverflow.com/questions/2304052/check-if-a-number-has-a-decimal-place-is-a-whole-number)
            if (value % 1 === 0) {
                return `${value} ${units[0]}`;
            } else {
                return `${value.toFixed(2)} ${units[0]}`;
            }
        }

        return this.formatBytes(value / 1024, units.slice(1));
    }

    triggerEvent() {
        // Set the column filter in the flow Repository
        let columnFilter = ' TRUE ';
        if (this.minValue > this.options.floor || this.maxValue < this.options.ceil) {
          columnFilter = ` ${this.fieldName} >= ${this.minValue} and ${this.fieldName} <= ${this.maxValue} `;
        }
        this.flowsRepository.datagridFilterMap.set(this.fieldName, columnFilter);


        this.changes.emit(true);
    }

    accepts(item: any) {
        let itemFieldValue = item[this.fieldName];

        if (this.filterIsActive) {
            return itemFieldValue >= this.minValue && itemFieldValue <= this.maxValue;
        }
        return true;
    }

    isActive(): boolean {
        if (this.minValue > this.options.floor || this.maxValue < this.options.ceil) {
          return true;
        }
        return false;
    }
}
